import { Box, ButtonSize, Tag, Text } from '@bechtel/gds';
import { getSplittedToolCatalogName } from '@bechtel/ht-clients-common';
import { ToolInventory } from '@bechtel/ht-types';
import { FC, useContext, useMemo } from 'react';
import { ActionContent } from '~/components/action-content';
import { ImageFallback } from '~/components/image-fallback';
import UserDetail from '~/components/molecules/user-details';
import { SecondaryButtonStyled } from '~/styles';
import { ReturnItemStyled } from '../../list/item/styled';
import { ReturnToolContext } from '../../return-tool-context';
import { actionType } from '../../types';
import { SearchToolInventoryItemProps } from './types';

const SearchToolInventoryItem: FC<SearchToolInventoryItemProps> = ({ item }: any) => {
  const { selectedCheckInToolList, updateData } = useContext(ReturnToolContext);

  let isAddBtnDisabled: boolean = false;
  if (selectedCheckInToolList && selectedCheckInToolList?.length > 0) {
    isAddBtnDisabled = selectedCheckInToolList.findIndex((oldList: ToolInventory) => oldList.id === item.id) != -1;
  }
  const detail = useMemo(() => getSplittedToolCatalogName(item?.description ?? ''), [item?.description]);

  const isSerialised = item?.isSerialized;

  return (
    <ReturnItemStyled>
      <Box justifyContent={{ sm: 'space-between' }}>
        <Box alignItems={{ sm: 'center' }} style={{ flex: 1 }}>
          <Box
            justifyContent={{ sm: 'center' }}
            alignItems={{ sm: 'center' }}
            my={{ sm: '200' }}
            ml={{ sm: '300' }}
            mr={{ sm: '500' }}
          >
            <ImageFallback
              src={item?.toolCatalog?.toolCatalogImageUrl}
              fallbackName={item?.toolCatalog?.toolCategory?.name}
            />
          </Box>
          <Box flexDirection={{ sm: 'column' }} style={{ flex: '1' }}>
            <div>
              <Tag bgColor={isSerialised ? 'orange.200' : 'neutral.200'}>
                <Text size="250" family={'openSansCondensed'}>
                  {item?.barCode}
                </Text>
              </Tag>
            </div>
            <Box mt={{ sm: '200' }}>
              <Text color="grey.900" weight="600" size="450" family={'openSans'}>
                {detail.title}
              </Text>
            </Box>
            {detail.subTitle && (
              <Box mt={{ sm: '200' }} px={{ sm: '200' }}>
                <Text color="grey.600" weight="100" size="300" family={'openSans'}>
                  {detail.subTitle}
                </Text>
              </Box>
            )}
          </Box>
        </Box>
        {item?.currentlyIssuedToUser && (
          <Box pl={{ sm: '700' }}>
            <UserDetail item={item?.currentlyIssuedToUser} hideIcon={true} />
          </Box>
        )}

        <SecondaryButtonStyled
          onClick={() => {
            updateData && updateData(actionType.ADD, { checkInToolList: [item] });
          }}
          style={{ marginTop: '12px', marginLeft: '50px' }}
          disabled={isAddBtnDisabled}
          size={ButtonSize.SMALL}
        >
          <ActionContent icon="plus" label="Add" />
        </SecondaryButtonStyled>
      </Box>
    </ReturnItemStyled>
  );
};

export default SearchToolInventoryItem;
